import { render, staticRenderFns } from "./project-connect-content.vue?vue&type=template&id=4497c60a&scoped=true"
import script from "./project-connect-content.vue?vue&type=script&lang=js"
export * from "./project-connect-content.vue?vue&type=script&lang=js"
import style0 from "./project-connect-content.vue?vue&type=style&index=0&id=4497c60a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497c60a",
  null
  
)

export default component.exports